module.exports = __webpack_public_path__ + "img/7.9dcc04db.jpg";